import * as Yup from "yup";
import { emailErrorMessage,requiredMessage } from "./errorMessage";



export const LOGIN_VALIDATION = {
  EMAIL: Yup.string().email(emailErrorMessage).required(requiredMessage),
  PASSWORD: Yup.string().required(requiredMessage),
};
